import {
  activeTabColor,
  editable,
  gapUnderTab,
  moduleTypeSelect,
  moduleWidthSelect,
  posterGap,
  regularTabColor,
  resizingOptionsSelect,
  tabStyle,
  tabs,
} from '@/src/tools/contentModulesFieldName';
import {
  EPreviewSize,
  SalesChannelModeWithSister,
} from '@/src/types/common/SalesChannel';
import {
  EModuleWidth,
  EResponsivePosterGap,
  EResponsivePosterType,
  EResponsiveResizingOption,
  EnumModuleType,
} from '@/src/types/common/module';
import i18n from '../i18n';
import { ModalField, ResponsiveContainer, ResponsiveField } from '../util';
import {
  ANIMATION,
  MOUDLE_STYLE,
  TAB,
  TABSTYLE,
  TAB_LIST,
  animationFields,
  moduleStyleFields,
} from './constant';
import { tabTypeOptionsGenerator } from './tools';

export default (
  values: any,
  responsiveType: EPreviewSize,
  salesChannelMode: SalesChannelModeWithSister,
) => {
  const tabSetting = getTabTemplate(values, responsiveType, salesChannelMode);
  const moduleStyleSetting = getModuleStyleTemplate(
    values,
    responsiveType,
    EnumModuleType.ResponsivePosterTab,
  );
  const animation = getAnimationTemplate(values, responsiveType);
  const tabStyleSetting = getTabStyleTemplate(values, responsiveType);
  const tabBarSetting = getTabBarListTemplate(values, responsiveType);
  return [
    {
      title: i18n['general.content.tab'],
      id: TAB,
      field: tabSetting,
      fields: [[moduleWidthSelect], [posterGap], [resizingOptionsSelect]],
    },
    {
      title: i18n['general.content.moduleStyle'],
      id: MOUDLE_STYLE,
      type: ResponsiveContainer.ModuleStyle,
      field: moduleStyleSetting,
      fields: moduleStyleFields,
    },
    {
      title: i18n['general.content.animation'],
      id: ANIMATION,
      field: animation,
      fields: animationFields,
    },
    {
      title: i18n['general.content.tabstyle'],
      id: TABSTYLE,
      field: tabStyleSetting,
      fields: [
        [tabStyle, gapUnderTab],
        [tabStyle, regularTabColor],
        [tabStyle, activeTabColor],
      ],
    },
    {
      title: i18n['general.content.tabSetting'],
      id: TAB_LIST,
      field: tabBarSetting,
      fields: [[tabs]],
    },
  ];
};

export const not_editable = [
  moduleTypeSelect,
  moduleWidthSelect,
  ...moduleStyle_not_editable,
  ...animation_not_editable,
  [tabStyle, regularTabColor],
  [tabStyle, activeTabColor],
];

export const getTabTemplate = (
  values: any,
  responsiveType: EPreviewSize,
  salesChannelMode: SalesChannelModeWithSister,
) => {
  const v =
    responsiveType === EPreviewSize.WIDE || values[`${TAB}_${editable}`];
  const commonFields = [
    {
      field: ResponsiveField.TabType,
      disabled: responsiveType !== EPreviewSize.WIDE || !v,
      options: tabTypeOptionsGenerator({ salesChannelMode }),
    },
    {
      field: ResponsiveField.ModuleWidth,
      disabled: responsiveType !== EPreviewSize.WIDE || !v,
      options: [
        { label: i18n['general.content.none'], value: EModuleWidth.NONE },
        { label: i18n['general.content.wideWidth'], value: EModuleWidth.WIDE },
        { label: i18n['general.content.fullWidth'], value: EModuleWidth.FULL },
      ],
    },
    {
      field: ResponsiveField.Gap,
      disabled: !v,
      options: [
        {
          label: i18n['general.postergap.none'],
          value: EResponsivePosterGap.NONE,
        },
        {
          label: i18n['general.postergap.small'],
          value: EResponsivePosterGap.SMALL,
        },
        {
          label: i18n['general.postergap.middle'],
          value: EResponsivePosterGap.MIDDLE,
        },
        {
          label: i18n['general.postergap.large'],
          value: EResponsivePosterGap.LARGE,
        },
      ],
    },
    {
      field: ResponsiveField.ResizingOption,
      disabled: !v,
      options: [
        {
          label: i18n['general.content.fixed'],
          value: EResponsiveResizingOption.FIXED,
        },
        {
          label: i18n['general.content.scalable'],
          value: EResponsiveResizingOption.SCALABLE,
        },
      ],
    },
  ];
  return commonFields;
};

export const getTabStyleTemplate = (
  values: any,
  responsiveType: EPreviewSize,
) => {
  // tab product content tablet&mobile 不可编辑颜色 || values[`${TABSTYLE}_${editable}`]
  const v =
    responsiveType === EPreviewSize.WIDE || values[`${TABSTYLE}_${editable}`];
  return [
    {
      field: ResponsiveField.TabStyle,
      disabled: responsiveType !== EPreviewSize.WIDE || !v,
      sliderDisabled: !v,
    },
  ];
};

import { get } from 'lodash';
import {
  animation_not_editable,
  getAnimationTemplate,
  getModuleStyleTemplate,
  moduleStyle_not_editable,
} from './imageCarousel';
import { getLayerTemplate } from './layer';

export const getTabBarListTemplate = (
  values: any,
  responsiveType: EPreviewSize,
) => {
  const v =
    responsiveType === EPreviewSize.WIDE || values[`${TAB_LIST}_${editable}`];
  const tabs = get(values, 'tabs', []) || [];
  const list = tabs.map((tab, index) => {
    return {
      field: ResponsiveField.TabBarSetting,
      disabled: !v,
      options: posterType,
      hasModal: true,
      modalFunc: getModalTemplate,
      extra: {
        index,
        tabDraggableId: get(tab, 'draggableId'),
        title: get(tab, 'title'),
      },
    };
  });
  return [{ field: ResponsiveField.AllTabs, disabled: !v }, ...list];
};

export const getModalTemplate = (layerValue: any) => {
  const layerTemplate = getLayerTemplate(layerValue);
  return {
    left: [
      { field: ModalField.Name },
      { field: ModalField.Image },
      { field: ModalField.Layer },
    ],
    middle: layerTemplate.left,
    right: layerTemplate.right,
  };
};

const posterType = [
  {
    label: i18n['general.postertype.one'],
    value: EResponsivePosterType.ONE,
  },
  {
    label: i18n['general.postertype.twoinone1'],
    value: EResponsivePosterType.TWO_1_1,
  },
  {
    label: i18n['general.postertype.twoinone2'],
    value: EResponsivePosterType.TWO_1_2,
  },
  {
    label: i18n['general.postertype.twoinone3'],
    value: EResponsivePosterType.TWO_2_1,
  },
  {
    label: i18n['general.postertype.three'],
    value: EResponsivePosterType.THREE,
  },
  {
    label: i18n['general.postertype.four'],
    value: EResponsivePosterType.FOUR,
  },
  {
    label: i18n['general.postertype.five'],
    value: EResponsivePosterType.FIVE,
  },
  {
    label: i18n['general.postertype.six'],
    value: EResponsivePosterType.SIX,
  },
  ,
];
